import React, { useState } from 'react'
import './App.scss'
import { Router, Switch, Route, NavLink } from 'react-router-dom'
import HomePageContainer from './app/home/components/HomePageContainer'
import PrintPageContainer from './app/print/component/PrintPageContainer'
import MarkUnprintedPageContainer from './app/mark-unprinted/MarkUnprintedPageContainer'
import OrderItemPageContainer from './app/order-item/component/OrderItemPageContainer'
import OrderLabelPageContainer from './app/order-label-v2/components/OrderLabelPageContainer'
import LabelsPageContainer from './app/labels/components/LabelsPageContainer'
import BasketsPageContainer from './app/baskets/components/BasketsPageContainer'
import MergerPageContainer from "./app/merger-v2/components/MergerPageContainer"
import BasketDetailPageContainer from "./app/basket-detail-v2/components/BasketDetailPageContainer"
import BatchesMarkPrinted from './app/batches-mark-printed/components/MarkPrinted'
import BatchesMarkQc from './app/batches-mark-qc-v3/components/MarkQC'
import BatchesPageContainer from './app/batchesV3/components/BatchesPageContainerV3'
import BatchPage from "./app/batch/components/BatchPage"
import PartnersPage from './app/partners/components/PartnersPage'
import PartnerContainer from './app/partner/components/PartnerContainer'
import UpdateBatchesContainer from "./app/update-batches/components/UpdateBatchesContainer"
import getHistory from './helpers/rounting/getHistory'
import MarkItemPrintedContainer from './app/mark-item-printed/components/MarkItemPrintedContainer'
import BatchesMarkTransferredContainer from './app/batches-mark-transferred/component/BatchesMarkTransferredContainer'
import DashboardContainer from './app/dashboard/components/DashboardContainer'
import ReGenerateContainer from './app/re-generate/component/ReGenerateContainer'
import ListJobContainer from "./app/list-job-labels/components/ListJobContainer"
import JobsGeneratedContainer from './app/jobs-generated/components/JobsGeneratedContainer'
import InCardContainer from './app/in-card/components/InCardContainer'
import StaticBatchesContainer from "./app/static-batches/components/StaticBatchesContainer"
import BatchReproductionContainer from "./app/batch-reproduction/components/BatchReproductionContainer"
import ItemReproductionContainer from "./app/item-reproduction/components/ItemReproductionContainer"
import LazeCuttingPageContainer from "./app/laze-cutting/components/LazeCuttingPageContainer"
import ListLazePageContainer from "./app/list-laze/components/ListLazePageContainer"
import ItemPieceErrorContainer from './app/items-piece-error/components/ItemPieceErrorContainer'
import ItemsErrorContainer from "./app/items-error/components/ItemsErrorContainer"
import LoginContainer from "./app/login/components/LoginContainer"
import EnsureLoggedIn from './app/shared/EnsureLoggedIn'
import UsersContainers from "./app/users/components/UsersContainers"
import { getLocalData } from "./services/StorageServices"
import MenuRight from "./helpers/MenuRight"
import MarkPackagedPageContainer from "./app/packing/components/MarkPackagedPageContainer"
import ListPackagedPageContainer from "./app/packing/components/ListPackagedPageContainer"
import PackingItemPageContainer from './app/packing-item/components/PackingItemPageContainer'
import AttachTagItemPageContainer from './app/attach-tag-item/components/AttachTagItemPageContainer'
import MarkOrdersPackagedPageContainer from "./app/orders-packing/components/MarkPackagedPageContainer"
import SewingRepairContainer from './app/sewing-repair/components/SewingRepairContainer'
import SewingRepairInBatchContainer from './app/sewing-repair-in-batch/components/SewingRepairInBatchContainer'
import MexPageContainer from './app/mex/components/MexPageContainer'
import ListMexPageContainer from './app/list-mex/components/ListMexPageContainer'
import RuleCreateBatchContainer from './app/rule-create-batch/components/RuleCreateBatchContainer'
import CreateRuleContainer from './app/rule-create-batch/components/Actions/CreateRuleContainer'
import UpdateRuleContainer from './app/rule-create-batch/components/Actions/UpdateRuleContainer'
import LazeCuttingErrorContainer from './app/list-laze-error/components/LazeCuttingErrorContainer'
import StatisticsAddBasketContainer from './app/basket-statistics/components/StatisticsAddBasketContainer'
import StatisticsDeleteBasketContainer from './app/basket-statistics/components/StatisticsDeleteBasketContainer'
import StatisticsUncompleteBasketContainer from './app/basket-statistics/components/StatisticsUncompleteBasketContainer'
import BatchesMarkPeriodsContainer from './app/batches-mark-periods/components/BatchesMarkPeriodsContainer'
import ListStageCompleteContainer from './app/list-periods/components/ListPeriodsContainer'
import UploadArtworkContainer from './app/upload-artwork/components/UploadArtworkContainer'
import { Tooltip, Menu, Dropdown, Icon } from "antd"
import { getLocalIP } from './helpers/getLocalIP'
import ColorSystemContainer from './app/color-system/component/ColorSystemContainer'
import ListUnpushKitCardContainer from './app/list-unpush-kit-card/components/ListUnpushKitCardContainer'
import ItemColorSystemContainer from './app/items-color-system/components/ItemColorSystemContainer'
import SewingGroupContainer from './app/sewing-group/components/SewingGroupContainer'
import EmbroideryContainer from './app/embroidery/components/EmbroideryContainer'
import {parseJwt} from "./helpers/parseToken"
import { notification } from 'antd'
import EmbroideryErrorContainer from './app/embroidery-error/components/EmbroideryErrorContainer'
import EmbroideryErrorInBatchContainer from './app/embroidery-error-in-batch/components/EmbroideryErrorInBatchContainer'
import ListUnpushEmbroideryContainer from './app/list-unpush-embroidery/components/ListUnpushEmbroideryContainer'
import ReuseEmbroideryInfoContainer from './app/reuse-embroidery-info/components/ReuseEmbroideryInfoContainer'
import MergerSetPageContainer from './app/merger-set/components/MergerSetPageContainer'
import BasketsMergeSetPageContainer from './app/baskets-merge-set/components/BasketsMergeSetPageContainer'
import CombinedSetStatisticsContainer from './app/combined-set-statistics/components/CombinedSetStatisticsContainer'
import GroupBatchContainer from './app/group-batch/components/GroupBatchContainer'
import ListGroupBatchContainer from './app/group-batch/components/ListGroupBatchContainer'
import ColorCheckItemContainer from './app/color-check-item/components/ColorCheckItemContainer'
import BasketsDuplicateContainer from './app/baskets-duplicate/components/BasketsDuplicateContainer'
import OriginalFileManagementPageContainer from './app/original-file-management/components/OriginalFileManagementPageContainer'
import AttachTagPageContainer from './app/attach-tag/components/AttachTagPageContainer'
import FbaItemDesignContainer from './app/fba-item-design/components/FbaItemDesignContainer'
import RequestPhotoContainer from './app/request-photo/components/RequestPhotoContainer'
import SewingHandoverContainer from './app/sewing-handover/components/handover/SewingHandoverContainer'
import SewingProductivityPage from './app/sewing-productivity-statistics/SewingProductivityPage'
import SewingThreadColorContainer from './app/sewing-thread-color/components/SewingThreadColorContainer'
import SewingHandoverHistoryContainer from './app/sewing-handover/components/history/SewingHandoverHistoryContainer'
import SewingHandoverPrintContainer from './app/sewing-handover/components/print/SewingHandoverPrintContainer'
import { MAIN_MENU_ITEMS, OTHER_MENU_ITEMS, filterMenuItems } from './app/shared/main-menu/mainMenuItems'

getLocalIP(1).then(ip => sessionStorage.setItem('lanIp', ip))

function App() {
    const history = getHistory()
    const tokenData = getLocalData('accessToken')
    const [token, setToken] = useState(tokenData)

    const role = parseJwt(token).roles || []
    const isAdmin = role.some(item => item.name === "fac_admin")
    const _setToken = (token) => {
        setToken(token)
    }

    history.listen(() => {
        notification.destroy();
    })

    const menu = (
        <Menu>
            {OTHER_MENU_ITEMS.reduce((nodes, item, index) => {
                if (index > 0) nodes.push(<Menu.Divider key={`divider-${item.to}`} />)
                nodes.push(
                    <Menu.Item key={item.to}>
                        <NavLink exact to={item.to} className="nav-link">
                            {item.label}
                        </NavLink>
                    </Menu.Item>
                )
                return nodes
            }, [])}
        </Menu>
    );

    return (
        <div className="App bg-light">
            <Router history={getHistory()}>
                <Switch>
                    <Route exact path="/login">
                        <LoginContainer onChangeToken={_setToken}/>
                    </Route>
                    <EnsureLoggedIn>
                        <div className="MenuHeader">
                            {
                                history.location.pathname !== '/batches/mark-printed' && <header>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 MenuHeaderCustom">
                                                <ul className="nav MainMenu">
                                                    {filterMenuItems(MAIN_MENU_ITEMS, isAdmin).map((item) => {
                                                        const link = (
                                                            <NavLink exact={item.exact !== false} to={item.to} className="nav-link">
                                                                {item.label}
                                                            </NavLink>
                                                        )

                                                        return (
                                                            <li className="nav-item" key={item.to}>
                                                                {item.tooltip ? <Tooltip title={item.tooltip}>{link}</Tooltip> : link}
                                                            </li>
                                                        )
                                                    })}
                                                    <li className="nav-item">
                                                        <Dropdown overlay={menu} trigger={['click']}>
                                                            <NavLink exact to="Khac" onClick={e => e.preventDefault()} className="nav-link">
                                                                Khác <Icon type="down" />
                                                            </NavLink>
                                                        </Dropdown>
                                                    </li>
                                                </ul>
                                                <MenuRight token={token}/>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                            }

                            <main>
                                <Switch>
                                    <Route exact path="/batches/packing" component={MarkPackagedPageContainer}/>

                                    <Route exact path="/batches/packing/list" component={ListPackagedPageContainer}/>

                                    <Route exact path="/orders/packing" component={MarkOrdersPackagedPageContainer}/>

                                    <Route exact path="/">
                                        <HomePageContainer history={history}/>
                                    </Route>

                                    <Route exact path="/mark-printed">
                                        <PrintPageContainer/>
                                    </Route>

                                    <Route exact path="/unmark-printed">
                                        <MarkUnprintedPageContainer/>
                                    </Route>

                                    <Route exact path="/order-item" component={OrderItemPageContainer}/>

                                    <Route exact path="/order-label" component={OrderLabelPageContainer}/>

                                    <Route exact path="/labels" component={LabelsPageContainer}/>

                                    <Route exact path="/baskets" component={BasketsPageContainer}/>

                                    <Route exact path="/baskets/:id" component={BasketDetailPageContainer}/>

                                    <Route exact path="/baskets-duplicate" component={BasketsDuplicateContainer}/>

                                    <Route exact path="/merger" component={MergerPageContainer}/>

                                    <Route exact path="/batches/mark-printed" component={BatchesMarkPrinted}/>

                                    <Route exact path="/batches/mark-qc" component={BatchesMarkQc}/>

                                    <Route exact path="/batches" component={BatchesPageContainer}/>

                                    <Route
                                        exact path="/batches/mark-transferred"
                                        component={BatchesMarkTransferredContainer}
                                    />

                                    <Route exact path="/batches/:id" component={BatchPage}/>

                                    <Route exact path="/partners" component={PartnersPage}/>

                                    <Route exact path="/markitemprinted" component={MarkItemPrintedContainer}/>

                                    <Route exact path="/partners/:id" component={PartnerContainer}/>

                                    <Route exact path="/updatebatches" component={UpdateBatchesContainer}/>

                                    <Route exact path="/dashboard" component={DashboardContainer}/>

                                    {isAdmin && <Route exact path="/re-generate" component={ReGenerateContainer}/>}

                                    <Route exact path="/list-job-labels" component={ListJobContainer}/>

                                    <Route exact path="/jobs-generated" component={JobsGeneratedContainer}/>

                                    <Route exact path="/in-card" component={InCardContainer}/>

                                    <Route exact path="/static-batches" component={StaticBatchesContainer}/>

                                    <Route exact path="/batch-reproduction" component={BatchReproductionContainer}/>

                                    <Route exact path="/items-error" component={ItemsErrorContainer}/>

                                    <Route exact path="/users" component={UsersContainers}/>

                                    <Route exact path="/item-reproduction" component={ItemReproductionContainer}/>

                                    <Route exact path="/laze-cutting" component={LazeCuttingPageContainer}/>

                                    <Route exact path="/mex" component={MexPageContainer}/>

                                    <Route exact path='/list-laze' component={ListLazePageContainer}/>

                                    <Route exact path='/item-piece-error' component={ItemPieceErrorContainer}/>

                                    <Route exact path='/color-system-error' component={ColorSystemContainer}/>

                                    <Route exact path='/item-color-system-error' component={ItemColorSystemContainer}/>

                                    <Route exact path="/list-laze" component={ListLazePageContainer}/>

                                    <Route exact path="/list-mex" component={ListMexPageContainer}/>

                                    <Route exact path="/packing-item" component={PackingItemPageContainer}/>

                                    <Route exact path="/attach-tag-item" component={AttachTagItemPageContainer}/>

                                    <Route exact path="/sewing-repair" component={SewingRepairContainer}/>
                                    
                                    <Route exact path="/sewing-repair-in-batch" component={SewingRepairInBatchContainer}/>
                                    
                                    <Route exact path="/embroidery" component={EmbroideryContainer} />

                                    <Route exact path="/embroidery-error" component={EmbroideryErrorContainer}/>
                                    
                                    <Route exact path="/embroidery-error-in-batch" component={EmbroideryErrorInBatchContainer}/>

                                    <Route exact path="/list-rule-create-batch" component={RuleCreateBatchContainer}/>

                                    <Route exact path="/create-rule" component={CreateRuleContainer}/>

                                    <Route exact path="/edit-rule/:id" component={UpdateRuleContainer}/>

                                    <Route exact path="/list-laze-error" component={LazeCuttingErrorContainer}/>

                                    <Route exact path="/statistics-add-basket" component={StatisticsAddBasketContainer}/>

                                    <Route exact path="/statistics-delete-basket" component={StatisticsDeleteBasketContainer}/>

                                    <Route exact path="/statistics-uncomplete-basket" component={StatisticsUncompleteBasketContainer}/>

                                    <Route exact path="/mark-periods" component={BatchesMarkPeriodsContainer}/>
                                    
                                    <Route exact path="/list-periods" component={ListStageCompleteContainer}/>

                                    <Route exact path="/upload-artwork" component={UploadArtworkContainer}/>

                                    <Route exact path="/list-unpush-kit-card" component={ListUnpushKitCardContainer}/>

                                    <Route exact path="/list-unpush-embroidery" component={ListUnpushEmbroideryContainer} />
                                    
                                    <Route exact path="/sewing-group" component={SewingGroupContainer}/>

                                    <Route exact path="/reuse-embroidery-info" component={ReuseEmbroideryInfoContainer}/>
                                    
                                    <Route exact path="/merger-set" component={MergerSetPageContainer}/>
                                    
                                    <Route exact path="/baskets-merge-set" component={BasketsMergeSetPageContainer}/>

                                    <Route exact path="/group-batch" component={GroupBatchContainer}/>

                                    {isAdmin && <Route exact path="/original-file-management" component={OriginalFileManagementPageContainer}/>}

                                    <Route exact path="/list-group-batch" component={ListGroupBatchContainer}/>
                                    
                                    <Route exact path="/color-check-items" component={ColorCheckItemContainer}/>

                                    <Route exact path="/combined-set-statistics" component={CombinedSetStatisticsContainer}/>

                                    <Route exact path="/attach-tag" component={AttachTagPageContainer}/>
                                    <Route exact path="/fba-item-design" component={FbaItemDesignContainer}/>
                                    <Route exact path="/sewing-thread-color" component={SewingThreadColorContainer}/>
                                    <Route exact path="/request-photo" component={RequestPhotoContainer}/>
                                    <Route exact path="/sewing-handover" component={SewingHandoverContainer}/>
                                    <Route exact path="/sewing-productivity-statistics" component={SewingProductivityPage}/>
                                    <Route exact path="/sewing-handover/history" component={SewingHandoverHistoryContainer}/>
                                    <Route exact path="/sewing-handover/:id/print" component={SewingHandoverPrintContainer}/>
                                </Switch>
                            </main>
                        </div>
                    </EnsureLoggedIn>
                </Switch>
            </Router>
        </div>
    )
}

export default App
